import React, { createContext, useContext } from 'react';
import { useDownloadManager, type UseDownloadManagerResult } from '../hooks/useDownloadManager';

const DownloadManagerContext = createContext<UseDownloadManagerResult | undefined>(undefined);

export const DownloadManagerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const manager = useDownloadManager();
  return (
    <DownloadManagerContext.Provider value={manager}>
      {children}
    </DownloadManagerContext.Provider>
  );
};

export function useDownloadManagerContext(): UseDownloadManagerResult {
  const ctx = useContext(DownloadManagerContext);
  if (ctx === undefined) {
    throw new Error('useDownloadManagerContext must be used within DownloadManagerProvider');
  }
  return ctx;
}
